import React from 'react';
import { useTranslation } from 'react-i18next';

// import RedwoodLogo from 'assets/images/RedwoodLogo';
import BgImage from 'assets/images/bg-waves.svg';

import {
  FooterContainer,
  Container,
  InfoContainer,
  BrandContainer,
  BranText,
  Phone,
  CopyRight,
  List,
  ContactLink,
  Tagline,
  SectionTitle,
} from './Footer.styles';

const Footer = () => {
  const [t] = useTranslation('global');

  return (
    <FooterContainer $bgImage={BgImage}>
      <Container>
        <InfoContainer>
          <div>
            <BrandContainer>
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                xmlns="http://www.w3.org/2000/svg"
              >
                <defs>
                  <linearGradient
                    id="footerGradient"
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="100%"
                  >
                    <stop
                      offset="0%"
                      style={{ stopColor: '#7C3AED', stopOpacity: 1 }}
                    />
                    <stop
                      offset="100%"
                      style={{ stopColor: '#1E40AF', stopOpacity: 1 }}
                    />
                  </linearGradient>
                  <linearGradient
                    id="footerBorderGradient"
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="100%"
                  >
                    <stop
                      offset="0%"
                      style={{ stopColor: '#34D399', stopOpacity: 0.8 }}
                    />
                    <stop
                      offset="100%"
                      style={{ stopColor: '#A78BFA', stopOpacity: 0.8 }}
                    />
                  </linearGradient>
                </defs>
                <circle
                  cx="16"
                  cy="16"
                  r="15"
                  fill="url(#footerGradient)"
                  stroke="url(#footerBorderGradient)"
                  strokeWidth="1"
                />
                <g transform="translate(6, 6)">
                  <rect
                    x="2"
                    y="2"
                    width="2.5"
                    height="16"
                    fill="#FFFFFF"
                    rx="1.25"
                  />
                  <rect
                    x="4.5"
                    y="2"
                    width="8"
                    height="2.5"
                    fill="#FFFFFF"
                    rx="1.25"
                  />
                  <rect
                    x="4.5"
                    y="8.75"
                    width="6"
                    height="2.5"
                    fill="#FFFFFF"
                    rx="1.25"
                  />
                  <rect
                    x="10"
                    y="4.5"
                    width="2.5"
                    height="4.25"
                    fill="#FFFFFF"
                    rx="1.25"
                  />
                  <rect
                    x="7.5"
                    y="11.25"
                    width="2.5"
                    height="6.75"
                    fill="#FFFFFF"
                    rx="1.25"
                    transform="rotate(30 8.75 14.625)"
                  />
                  <circle cx="15" cy="5" r="1.2" fill="#34D399" />
                  <circle cx="15" cy="9" r="0.8" fill="#FBBF24" opacity="0.9" />
                  <circle
                    cx="15"
                    cy="12.5"
                    r="0.6"
                    fill="#A78BFA"
                    opacity="0.7"
                  />
                </g>
              </svg>
              <BranText>Redwood Tech</BranText>
            </BrandContainer>
            <Tagline>Data Engineering & AI Solutions</Tagline>
            <ContactLink href="https://www.redwoodtech.co" target="_blank">
              🌐 www.redwoodtech.co
            </ContactLink>
            <ContactLink href="mailto:contact@redwoodtech.co">
              ✉️ contact@redwoodtech.co
            </ContactLink>
            <CopyRight>
              <div>A trade name of Mr. Big Data LLC</div>
              <div>© 2020 - 2026 Redwood Tech. All Rights Reserved.</div>
            </CopyRight>
          </div>
          <div>
            <SectionTitle>{t('footer.call')}</SectionTitle>
            <Phone href="tel:+310646230760">🇳🇱 +31 064 623 0760</Phone>
            <Phone href="tel:+573134441693">🇨🇴 +57 313 444 1693</Phone>
          </div>
          <div>
            <SectionTitle>{t('footer.locations')}</SectionTitle>
            <List>
              <li>🇺🇸 Clearwater, USA</li>
              <li>2400 Feather Sound DR, Florida, 33762</li>
              <li style={{ marginTop: '16px' }}>🇨🇴 Barranquilla, Colombia</li>
              <li>Calle 135 #51c - 346</li>
            </List>
          </div>
        </InfoContainer>
      </Container>
    </FooterContainer>
  );
};

export default Footer;
